<!-- 区间的input统一组件 -->
<template>
  <x-input :title='title' :placeholder="placeholder" type="tel" :max='maxLen' :show-clear='false'  @on-blur="handleFocusLeft" v-model="currentValueLeft" @on-change="changeLv" class="buy-car">
    <div slot="right" class="buy-car__right">
      <span class="run-text">{{intervalText}}</span>
      <x-input placeholder="请输入" :show-clear='false' type="tel" :max='maxLen' label-width='0'  @on-blur="handleFocusRight" v-model="currentValueRight" @on-change="changeRv"></x-input>
      <span class="money-text">{{unit}}</span>
    </div>
  </x-input>
</template>

<script>
import { XInput } from '@lx-frontend/cvux'
import util from '../../common/util'
export default {
  name: 'intervalInput',
  components: { XInput },
  props: {
    title: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      default: '请输入'
    },
    // 区间文字
    intervalText: {
      type: String,
      default: '至'
    },
    // 单位
    unit: {
      type: String,
      default: '万'
    },
    valueL: {
      type: [String, Number],
      required: true
    },
    valueR: {
      type: [String, Number],
      required: true
    },
    maxLen: {
      type: Number,
      default: 3
    }
  },
  data() {
    return {
      currentValueLeft: '',
      currentValueRight: ''
    }
  },
  created() {
    this.currentValueLeft = `${this.valueL}` || ''
    this.currentValueRight = `${this.valueR}` || ''
  },
  watch: {
    currentValueLeft(newVal) {
      this.$emit('update:valueL', newVal)
    },
    currentValueRight(newVal) {
      this.$emit('update:valueR', newVal)
    },
    valueL(newVal) {
      this.currentValueLeft = `${newVal}` || ''
    },
    valueR(newVal) {
      this.currentValueRight = `${newVal}` || ''
    }
  },
  methods: {
    handleFocusLeft(value) {
      const { currentValueRight } = this
      if (util.isNumberEmpty(currentValueRight)) this.currentValueRight = value
    },
    handleFocusRight(value, type) {
      const { currentValueLeft } = this
      if (util.isNumberEmpty(currentValueLeft)) this.currentValueLeft = value
    },
    changeLv(value) {
      this.$nextTick(() => {
        this.currentValueLeft = value.replace(/\D/g, '')
      })
    },
    changeRv(value) {
      this.$nextTick(() => {
        this.currentValueRight = value.replace(/\D/g, '')
      })
    }
  }
}
</script>
<style lang='less' scoped>
@w2: 75rem;
.buy-car {
  justify-content: flex-start;
  /deep/ .weui_cell_primary {
    flex-basis: 108 / @w2!important;
    flex: none;
    input {
      width: 108 / @w2;
    }
  }
  &__right {
    width: 396 / @w2;
    color: #000;
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    .weui_cell {
      padding: 0;
    }
    .weui_cell:before {
      display: none;
    }
    .run-text {
      margin: 0 22px;
    }
    .money-text {
      margin-left: 22px;
    }
  }
}
</style>
